
import { requests } from '.'

export const LogApi = {
  addLog: (data: string) => requests.post<void>('v1/log', {data}), 
};